import script from "./PCBuscadorSalidasProduccion.vue?vue&type=script&setup=true&lang=js"
export * from "./PCBuscadorSalidasProduccion.vue?vue&type=script&setup=true&lang=js"

import "./PCBuscadorSalidasProduccion.vue?vue&type=style&index=0&id=25b63c58&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b63c58"]])

export default __exports__